import { useRef, useEffect } from 'react';

const logos = [
  {
    name: 'Programa UNIAO',
    src: 'https://storage.readdy-site.link/project_files/ad23bf20-8f1c-4820-8d59-048f8dd2f26d/1d30edb9-a063-44a2-83c1-a41eef39f3cb_UNIAO.png?v=0afb2ed5783890533c10b0600ff0668c',
  },
  {
    name: 'Expertise France',
    src: 'https://storage.readdy-site.link/project_files/ad23bf20-8f1c-4820-8d59-048f8dd2f26d/a36caa5c-3c68-4d45-aff8-61859365ff5e_R.png?v=2320502221d0495a0a325a2d23ba53dd',
  },
  {
    name: 'União Europeia',
    src: 'https://storage.readdy-site.link/project_files/ad23bf20-8f1c-4820-8d59-048f8dd2f26d/1793ec56-104b-4775-abef-2602761336f9_1_Untitled.jpg?v=ef02bd965bcefdaf6d9d821f7556eb58',
  },
  {
    name: 'MEDUMED',
    src: 'https://storage.readdy-site.link/project_files/ad23bf20-8f1c-4820-8d59-048f8dd2f26d/57ae4589-c08b-42ae-be7d-d7831ecb7bd2_MEDUMED.jpg?v=20d16276dfd8f096de32c6a5c5e274c9',
  },
  {
    name: 'Parceiro Institucional',
    src: 'https://storage.readdy-site.link/project_files/ad23bf20-8f1c-4820-8d59-048f8dd2f26d/972c3d9e-0d2c-4bca-9ca7-d410fee906f5_Screenshot-2026-04-28-075331.png?v=b15cd2bbb8ac6e62dcf84d004dc262e4',
  },
];

export default function LogoScroll() {
  const trackRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let animationId: number;
    let position = 0;
    const speed = 0.5;

    const animate = () => {
      position -= speed;
      const firstChild = track.firstElementChild as HTMLElement;
      if (firstChild && Math.abs(position) >= firstChild.offsetWidth + 48) {
        position += firstChild.offsetWidth + 48;
        track.appendChild(firstChild);
      }
      track.style.transform = `translateX(${position}px)`;
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationId);
  }, []);

  return (
    <section className="py-12 md:py-16 bg-white border-t border-gray-100">
      <div className="w-full px-4 md:px-8 lg:px-12 mb-8">
        <div className="max-w-6xl mx-auto text-center">
          <span className="text-accent text-sm font-semibold uppercase tracking-wider">Apoio Institucional</span>
          <h2 className="font-display text-2xl md:text-3xl font-bold text-primary mt-2">
            Parceiros e Financiadores
          </h2>
        </div>
      </div>

      <div className="relative overflow-hidden">
        <div className="absolute left-0 top-0 bottom-0 w-16 md:w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-16 md:w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

        <div
          ref={trackRef}
          className="flex items-center gap-12 px-6"
          style={{ willChange: 'transform' }}
        >
          {[...logos, ...logos].map((logo, i) => (
            <div
              key={`${logo.name}-${i}`}
              className="flex-shrink-0 w-36 h-24 md:w-44 md:h-28 bg-white rounded-xl border border-gray-100 flex items-center justify-center px-4 hover:border-accent/30 transition-colors"
              title={logo.name}
            >
              <img
                src={logo.src}
                alt={logo.name}
                className="max-w-full max-h-full object-contain"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}